import { Col, Input, Row, Tag } from "antd";
import { useWatch } from "antd/lib/form/Form";
import BooleanDisplay from "components/ui/BooleanDisplay";
import Claims from "features/auth/claims";
import useAuth from "features/auth/useAuth";
import { FormMode } from "models/common";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { FormUtils, GrapeAntdForm, email, requiredField } from "widgets/form";

interface UserFormItemsProps {
  formUtils: FormUtils;
  formMode?: FormMode;
}

const UserFormItems: FC<UserFormItemsProps> = ({ formUtils, formMode }) => {
  const { t } = useTranslation();
  const orgNameValue = useWatch("orgName", formUtils.form);
  const { hasClaim } = useAuth();

  const isUserUpdateLimited =
    (hasClaim([Claims.User.UpdateLimited]) &&
      !hasClaim([Claims.User.Update]) &&
      orgNameValue) ||
    (!hasClaim([Claims.User.UpdateLimited]) && !hasClaim([Claims.User.Update]));

  return (
    <Row justify="start" gutter={[28, 16]}>
      <Col span={8}>
        <GrapeAntdForm.Item
          name="familyname"
          label={t("settings.users.familyName")}
          rules={[requiredField(t)]}
        >
          <Input size="large" disabled={isUserUpdateLimited} />
        </GrapeAntdForm.Item>
      </Col>
      <Col span={8}>
        <GrapeAntdForm.Item
          name="middlename"
          label={t("settings.users.middleName")}
        >
          <Input size="large" disabled={isUserUpdateLimited} />
        </GrapeAntdForm.Item>
      </Col>
      <Col span={8}>
        <GrapeAntdForm.Item
          name="forename"
          label={t("settings.users.forename")}
          rules={[requiredField(t)]}
        >
          <Input size="large" disabled={isUserUpdateLimited} />
        </GrapeAntdForm.Item>
      </Col>
      <Col span={8}>
        <GrapeAntdForm.Item
          name="username"
          label={t("settings.users.username")}
          rules={[requiredField(t), email(t)]}
        >
          <Input size="large" />
        </GrapeAntdForm.Item>
      </Col>

      {formMode !== "Create" && (
        <Col span={8}>
          <GrapeAntdForm.Item
            name="orgName"
            label={t("settings.users.orgName")}
          >
            <Input size="large" disabled />
          </GrapeAntdForm.Item>
        </Col>
      )}

      {formMode !== "Create" && (
        <Col span={8}>
          <GrapeAntdForm.Item
            name="isRegistered"
            label={t("settings.users.isRegistered")}
          >
            <BooleanDisplay
              trueDisplay={<Tag>{t("common.yes")}</Tag>}
              falseDisplay={<Tag>{t("common.no")}</Tag>}
            />
          </GrapeAntdForm.Item>
        </Col>
      )}
    </Row>
  );
};

export default UserFormItems;
